// extracted by mini-css-extract-plugin
var _1 = "MagneticWallItem-module__actionContainer--yz9jv";
var _2 = "MagneticWallItem-module__animateUploadProgressBarWidth--XPXen";
var _3 = "MagneticWallItem-module__animatedBackground--RK74g";
var _4 = "MagneticWallItem-module__avatar--ejPia";
var _5 = "MagneticWallItem-module__avatarContainer--N6yZv";
var _6 = "MagneticWallItem-module__avatarContainerDisabled--qPWcT";
var _7 = "MagneticWallItem-module__buttonGroup--lStoV";
var _8 = "MagneticWallItem-module__card--okHTL";
var _9 = "MagneticWallItem-module__compactContainer--RHS3W";
var _a = "MagneticWallItem-module__focusable--D5oVE";
var _b = "MagneticWallItem-module__focused--b61IE";
var _c = "MagneticWallItem-module__fullContainer--wsRyc";
var _d = "MagneticWallItem-module__highlighted--mbaU7";
var _e = "MagneticWallItem-module__inner--_5IAN";
var _f = "MagneticWallItem-module__inset--aaDvy";
var _10 = "MagneticWallItem-module__item--zUxeS";
var _11 = "MagneticWallItem-module__minWidthDisabled--wn5Ul";
var _12 = "MagneticWallItem-module__overlapped--cAeG3";
var _13 = "MagneticWallItem-module__popOverContainer--tEEB1";
var _14 = "MagneticWallItem-module__sideTop--xeT38";
var _15 = "MagneticWallItem-module__wideContainer--vMrlL";
export { _1 as "actionContainer", _2 as "animateUploadProgressBarWidth", _3 as "animatedBackground", _4 as "avatar", _5 as "avatarContainer", _6 as "avatarContainerDisabled", _7 as "buttonGroup", _8 as "card", _9 as "compactContainer", _a as "focusable", _b as "focused", _c as "fullContainer", _d as "highlighted", _e as "inner", _f as "inset", _10 as "item", _11 as "minWidthDisabled", _12 as "overlapped", _13 as "popOverContainer", _14 as "sideTop", _15 as "wideContainer" }
